// Production's `useColorFromEnum` only knows color1 / color2. The multi-provider
// fixtures use color3+ for additional providers, so we extend the palette here
// rather than modifying the production hook (which would leak into /schedule).

export const EXTENDED_COLOR_PALETTE: Record<string, string> = {
  color1: '#6C00CC', // Purple — production primary
  color2: '#D46D27', // Orange — production secondary
  color3: '#2563EB', // Blue
  color4: '#059669', // Emerald
  color5: '#DB2777', // Pink
};

export const getExtendedColor = (colorEnum: string | null | undefined): string => {
  if (!colorEnum) return EXTENDED_COLOR_PALETTE.color1;
  return EXTENDED_COLOR_PALETTE[colorEnum] ?? EXTENDED_COLOR_PALETTE.color1;
};

// "Dr. Mariana Patel" → "MP" · "Sam Reynolds" → "SR" · "Dr. Jordan Chen" → "JC"
export const providerInitials = (name: string): string =>
  name
    .replace(/^(Dr|Mr|Mrs|Ms|Mx)\.?\s+/i, '')
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

// Stable hash → palette color. Used for avatars and badges where the entity
// has no curated color enum (e.g., real clinicians, waitlist patients).
const COLOR_KEYS = Object.keys(EXTENDED_COLOR_PALETTE);
export const getColorForId = (id: string): string => {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  }
  const key = COLOR_KEYS[hash % COLOR_KEYS.length];
  return EXTENDED_COLOR_PALETTE[key];
};
